import React from 'react';
import {FlatList, View} from 'react-native';
import {TouchableOpacity} from 'react-native';
import {useNavigation, useRoute} from '@react-navigation/native';
import {compact, get, isEmpty} from 'lodash';

import Button from '/component/base/Button';
import Text from '/component/base/Text';
import ModalHeader from '/component/layout/ModalHeader';
import {SearchAndFilter} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import {generateCallback} from '/util/component.util';
import {getFilterOptions} from '/util/filter.util';

import testProperties from '../../../../util/testing/testProperties';

import {FilterItem} from './FilterItem';
import {styles} from './FilterScreen.style';
import {generateOnPress} from './FilterScreen.util';

import {useRecordsFiltering} from '/context/RecordsFilter/useRecordsFiltering';

export function FilterScreen({}) {
  const navigation = useNavigation();
  const route = useRoute();

  const {tt} = useTranslation('filterScreen');
  const recordsName = get(route, 'params.recordsName', '');
  const setSelectedFilterParam = get(
    route,
    'params.setSelectedFilterParam',
    () => {},
  );

  const filterOptions = getFilterOptions({recordsName});

  const {filterParam: newFilterParam} = useRecordsFiltering({
    recordsName: recordsName,
  });

  const onClose = generateCallback({func: navigation.goBack});

  const onApply = generateOnPress({
    filterParam: newFilterParam,
    setSelectedFilterParam,
    recordsName,
    goBack: navigation.goBack,
    isApplyAction: true,
  });

  const onClear = generateOnPress({
    filterParam: {},
    setSelectedFilterParam,
    recordsName,
  });

  const flatListItem = ({item}: any) => (
    <FilterItem
      item={item}
      filterParam={newFilterParam[recordsName]}
      setSelectedFilterParam={setSelectedFilterParam}
    />
  );

  const hasValidValue = (obj: any) => {
    if (obj && typeof obj === 'object') {
      return Object.values(obj).some(
        value => value !== undefined && value !== null && value !== '',
      );
    }
    return false;
  };
  const count = hasValidValue(newFilterParam) ? 1 : 0;
  const renderFooter = () => (
    <View style={styles.clearFilters}>
      <Button
        accessible={true}
        style={{base: styles.clearFiltersButton}}
        type="secondary"
        disabled={isEmpty(newFilterParam)}
        onPress={onClear}
        accessibilityLabel={`Clear all filters, ${
          isEmpty(newFilterParam) ? 'disabled' : 'enabled'
        }`}
        accessibilityState={{disabled: isEmpty(newFilterParam)}}
        {...testProperties(SearchAndFilter.searchFilterClearAllFilters)}>
        {tt('clearFilters', 'Clear all filters')}
      </Button>
    </View>
  );

  return (
    <ModalHeader
      style={{
        base: styles.base,
        headerText: styles.headerText,
      }}
      recordsName={recordsName}
      title={tt('title', 'Filter')}
      titleVariant="medium"
      onClose={onClose}
      closeIconName="chevron-left"
      actionLabel={tt('action.applyFilter', 'Apply')}
      onActionPress={recordsName === 'SEARCH' ? onApply : ''}>
      {recordsName === 'SEARCH' ? (
        <FlatList
          data={compact(filterOptions)}
          renderItem={flatListItem}
          ListFooterComponent={renderFooter}
        />
      ) : (
        <FlatList data={compact(filterOptions)} renderItem={flatListItem} />
      )}

      {recordsName !== 'SEARCH' && (
        <View style={styles.clearBottoncontainer}>
          <TouchableOpacity
            onPress={onClear}
            style={styles.clearButton}
            accessibilityRole="button"
            accessibilityLabel={tt('clearFilters', `Clear filters (${count})`)}>
            <View>
              <Text style={styles.buttonText} isBold>
                {tt('clearFilters', `Clear filters (${count})`)}
              </Text>
            </View>
          </TouchableOpacity>
        </View>
      )}
    </ModalHeader>
  );
}
